import { Comic } from '@/mocks/comics';

export function generateOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩国漫画网',
    url: 'https://www.example.com/',
    description: '韩国漫画网作为免费漫画平台，提供完整的韩漫大全市集与无缝在线观看服务。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@koreancomic.cn',
      telephone: '400-123-4567',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };
}

export function generateWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩国漫画网',
    url: 'https://www.example.com/',
    description: '韩国漫画网作为免费漫画平台，提供完整的韩漫大全市集与无缝在线观看服务，确保您能随时欣赏到心仪故事的全貌。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.example.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };
}

export function generateWebPageSchema(title: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url,
    isPartOf: {
      '@type': 'WebSite',
      name: '韩国漫画网',
      url: 'https://www.example.com/',
    },
  };
}

export function generateBreadcrumbListSchema(items: Array<{ name: string; url: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function generateComicSchema(comic: Comic) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ComicSeries',
    name: comic.title,
    author: {
      '@type': 'Person',
      name: comic.author,
    },
    description: comic.description,
    url: `https://www.example.com/article/${comic.id}`,
    image: comic.cover,
    genre: comic.tags,
    datePublished: comic.chapters[comic.chapters.length - 1]?.date || comic.updateDate,
    inLanguage: 'zh-CN',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: comic.rating,
      bestRating: 10,
      ratingCount: Math.floor(comic.views / 10),
    },
  };
}

export function generateFAQPageSchema(faqs: Array<{ q: string; a: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };
}